/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationContextClassLoaderParentUnnamedModuleDescriptor } from './ApplicationContextClassLoaderParentUnnamedModuleDescriptor';
import {
    ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSON,
    ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSONTyped,
    ApplicationContextClassLoaderParentUnnamedModuleDescriptorToJSON,
} from './ApplicationContextClassLoaderParentUnnamedModuleDescriptor';

/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModule
 */
export interface ApplicationContextClassLoaderParentUnnamedModule {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    name?: string;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleDescriptor}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    descriptor?: ApplicationContextClassLoaderParentUnnamedModuleDescriptor;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    named?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    annotations?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    declaredAnnotations?: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    packages?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    nativeAccessEnabled?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    layer?: object;
}

/**
 * Check if a given object implements the ApplicationContextClassLoaderParentUnnamedModule interface.
 */
export function instanceOfApplicationContextClassLoaderParentUnnamedModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextClassLoaderParentUnnamedModuleFromJSON(json: any): ApplicationContextClassLoaderParentUnnamedModule {
    return ApplicationContextClassLoaderParentUnnamedModuleFromJSONTyped(json, false);
}

export function ApplicationContextClassLoaderParentUnnamedModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContextClassLoaderParentUnnamedModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'descriptor': !exists(json, 'descriptor') ? undefined : ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSON(json['descriptor']),
        'named': !exists(json, 'named') ? undefined : json['named'],
        'annotations': !exists(json, 'annotations') ? undefined : json['annotations'],
        'declaredAnnotations': !exists(json, 'declaredAnnotations') ? undefined : json['declaredAnnotations'],
        'packages': !exists(json, 'packages') ? undefined : json['packages'],
        'nativeAccessEnabled': !exists(json, 'nativeAccessEnabled') ? undefined : json['nativeAccessEnabled'],
        'layer': !exists(json, 'layer') ? undefined : json['layer'],
    };
}

export function ApplicationContextClassLoaderParentUnnamedModuleToJSON(value?: ApplicationContextClassLoaderParentUnnamedModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'descriptor': ApplicationContextClassLoaderParentUnnamedModuleDescriptorToJSON(value.descriptor),
        'named': value.named,
        'annotations': value.annotations,
        'declaredAnnotations': value.declaredAnnotations,
        'packages': value.packages,
        'nativeAccessEnabled': value.nativeAccessEnabled,
        'layer': value.layer,
    };
}

